import { GridColumn } from '@grid/abstractions';
import { ColumnFilterDefinition } from '../../models/column-filter-definition';
import { filterByFilterableColumn } from './filter-by-filterable-column';
import { sortColumn } from './sort-columns';
import { checkVisibility } from './check-visibility';

export function parseToFilterGridColumn(
  columns: GridColumn[]
): ColumnFilterDefinition[] {
  return columns
    .filter(filterByFilterableColumn)
    .sort(sortColumn)
    .map(checkVisibility)
    .filter((column: GridColumn) => column.filterableColumn!.isVisible)
    .map((column: GridColumn) => new ColumnFilterDefinition(column));
}
